<template>
  <div class="modal fade" id="addDeviceModal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="close" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-info-circle mr-5"></i>{{'add_new_device' | translate}}</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-xs-12 mt-10">
              <div class="input-group">
                <div class="input-group-addon">
                  Device ID:
                </div>
                <input type="text" class="form-control" v-model="device.device_id"/>
              </div>
            </div>
            <div class="col-xs-12 mt-10">
              <div class="input-group">
                <div class="input-group-addon">
                  {{'in_use_by' | translate}}:
                </div>
                <input type="text" class="form-control" v-model="device.in_use_by"/>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button :disabled="loading" class="btn btn-success" @click="addDevice"><i :class="[loading ? 'fa fa-spinner fa-spin' : 'fa fa-check', 'mr-5']"></i>{{'save' | translate}}</button>
          <b-btn data-dismiss="modal" hidden type="button" id="closeModal"></b-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['storeId'],
  data () {
    return {
      loading: false,
      device: {
        device_id: '',
        in_use_by: ''
      }
    }
  },
  methods: {
    addDevice () {
      this.$emit('loading')
      this.loading = true
      API.post(`accounting/stores/${this.storeId}/wsDevices`, this.device)
        .then(response => {
          this.$emit('reload')
          this.$emit('alert', {type: 'success', dismiss: 4, message: 'Success!'})
          this.loading = false
          $('#closeModal').click()
        })
        .catch(() => {
          this.$emit('alert', {type: 'danger', dismiss: 4, message: 'ERROR'})
          this.$emit('loading')
          this.loading = false
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
    })
  },
  watch: {
  }
}
</script>
